import React from "react";

function HeroSection({title, eyebrow, subtitle, accent = "customer", actions}) {
    return (
        <div className="dashboard-hero" data-accent={accent}>
            <div>
                {eyebrow && <div className="dashboard-eyebrow">{eyebrow}</div>}
                {title && <h1>{title}</h1>}
                {subtitle && <p>{subtitle}</p>}
            </div>
            {actions && (
                <div className="dashboard-hero-actions">
                    {actions}
                </div>
            )}
        </div>
    );
}

export default HeroSection;
